<script setup>
import { computed, useAttrs } from 'vue';
import { cn } from 'dashboard/lib/utils';

const props = defineProps({
  modelValue: { type: [String, Number], default: '' },
  class: { type: [String, Object, Array], default: '' },
});

const emit = defineEmits(['update:modelValue']);

const attrs = useAttrs();

const model = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val),
});
</script>

<template>
  <input
    v-model="model"
    v-bind="attrs"
    :class="
      cn(
        'flex h-9 w-full rounded-md border border-[hsl(var(--input))] bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[hsl(var(--muted-foreground))] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[hsl(var(--ring))] disabled:cursor-not-allowed disabled:opacity-50',
        props.class
      )
    "
  />
</template>
